import Phaser from 'phaser';
import { tileSize } from '~/src/consts/sizes';
import {
  sceneEvents,
  EVENT_GAME_INITED,
  EVENT_PACMAN_HASPOWER,
  EVENT_PACMAN_LOSEPOWER,
  EVENT_GAME_LEVELUP,
  EVENT_PACMAN_LOSELIFE,
  EVENT_GAME_OVER,
  EVENT_GAME_UPDATESCORE,
  EVENT_GAME_START,
  EVENT_PACMAN_GAINLIFE
} from '~/src/events/GameEvents';
import { levels, START_LIVES, START_TIMER } from '../consts/config';
import { white } from '../game/colors';
import Game from './Game';
import Start from './Start';

export default class Menu extends Phaser.Scene {

  public static SceneName = 'MenuScene';

  private noticeText?: Phaser.GameObjects.Text;
  private scoreText?: Phaser.GameObjects.Text;
  private highScoreText?: Phaser.GameObjects.Text;
  private creditText?: Phaser.GameObjects.Text;
  private livesImages: Phaser.GameObjects.Image[] = [];
  private lives = 0;
  private score = 0;
  private highscore = 0;
  private level = 0;

  private _gameOverTimer?: Phaser.Time.TimerEvent;

  constructor() {
    super(Menu.SceneName);
  }

  create() {
    this.lives = START_LIVES;
    this.score = 0;
    this.level = 0;
    this.highscore = parseInt(localStorage.getItem('highscore') || '0', 10);


    const emulogic32pxWhite = {
      color: white.rgba,
      fontSize: '32px',
      fontFamily: 'Emulogic'
    };

    this.noticeText = this.add.text(
      tileSize * 4 * 8 - 48,
      tileSize * 4 * 9 + 28,
      'READY!',
      {
        color: white.rgba,
        fontSize: '48px',
        fontFamily: 'Emulogic',
        align: 'center',
      })
      .setOrigin(0.5, 0)
      .setVisible(false);

    this.scoreText = this.add.text(
      tileSize * 4,
      1,
      `1UP\n ${this.score}`,
      {
        ...emulogic32pxWhite
      })
      .setLineSpacing(2);

    this.highScoreText = this.add.text(
      tileSize * 4 * 7,
      1,
      `HIGH SCORE\n${this.highscore}`,
      {
        ...emulogic32pxWhite
      })
      .setOrigin(0.5, 0)
      .setLineSpacing(2);

    this.creditText = this.add.text(
      tileSize * 4,
      tileSize * 68,
      `CREDIT\t\t0`,
      { ...emulogic32pxWhite }
    );
    this.creditText.setVisible(false);

    this.updateLives();
    this.updateLevel();

    this.scene.launch(Start.SceneName);
    this.setupSceneEvents();
  }

  updateLevel() {
    // unique from 'levels', draw from right to left 
    [...new Set(levels.slice(0, this.level + 1))].map((fruit, i) =>
      this.add.image(tileSize * (54 - (i + 1) * 4), tileSize * 68, 'kebab_tiles', `${fruit}.png`)
    );
  }

  updateLives() {
    this.livesImages.forEach(life => life.destroy());
    this.livesImages = [...Array(this.lives)].map((x, i) =>
      this.add.image(tileSize * ((i + 1) * 4), tileSize * 68, 'kebab_tiles', 'hero2.png').setFlip(true, false)
    );
  }

  setupSceneEvents() {
    const audioSprite = this.sound.addAudioSprite('bgm');

    sceneEvents.on(EVENT_GAME_INITED, () => {
      audioSprite.play('opening');
      this.noticeText?.setVisible(true);
      this.time.addEvent({
        delay: START_TIMER,
        callback: () => {
          sceneEvents.emit(EVENT_GAME_START);
          this.noticeText?.setVisible(false);
          audioSprite.stop();
          audioSprite.play(`level${this.level % 4}`);
        },
      });
    });
    sceneEvents.on(EVENT_PACMAN_HASPOWER, () => {
      audioSprite.stop();
      audioSprite.play('frightened');
    });

    sceneEvents.on(EVENT_PACMAN_LOSEPOWER, () => {
      audioSprite.stop();
      audioSprite.play(`level${this.level % 4}`);
    });

    sceneEvents.on(EVENT_GAME_LEVELUP, (nextLevel) => {
      audioSprite.stop();
      audioSprite.play('level up');
      this.level = nextLevel;
      this.updateLevel();
    });

    sceneEvents.on(EVENT_PACMAN_LOSELIFE, () => {
      this.sound.stopAll();
      if (this.lives > 0) {
        this.livesImages[this.lives - 1].destroy();
        this.lives = Math.max(0, this.lives - 1);
      }
    });

    sceneEvents.on(EVENT_GAME_OVER, () => {
      if (this.score > this.highscore) {
        localStorage.setItem('highscore', `${this.score}`);
        this.highScoreText?.setText(`HIGH SCORE\n${this.highscore}`);
      }
      this.noticeText?.setPosition(this.scale.width * 0.5, this.scale.height * 0.5);
      this.noticeText?.setText('GAME OVER');
      this.noticeText?.setVisible(true);
      this.scene.stop(Game.SceneName);
      this._gameOverTimer = this.time.addEvent({
        delay: 5000,
        callback: () => window.location.reload(), //this.scene.restart(),
        loop: false,
        paused: false
      });
    });

    sceneEvents.on(EVENT_GAME_UPDATESCORE, (scores: number) => {
      this.score += scores;
      this.scoreText?.setText(`1UP\n${this.score}`);
      if (this.score >= 10000) {
        sceneEvents.emit(EVENT_PACMAN_GAINLIFE);
      }
    });

    const gainLife = () => {
      this.lives = this.lives + 1;
      this.updateLives();
      sceneEvents.off(EVENT_PACMAN_GAINLIFE, gainLife);
    };
    sceneEvents.on(EVENT_PACMAN_GAINLIFE, gainLife);


    const eventsOff = () => {
      sceneEvents.destroy();
      // sceneEvents.off(EVENT_PACMAN_HASPOWER);
      // sceneEvents.off(EVENT_PACMAN_LOSEPOWER);
      // sceneEvents.off(EVENT_GAME_LEVELUP);
      // sceneEvents.off(EVENT_PACMAN_LOSELIFE);
      // sceneEvents.off(EVENT_GAME_OVER);
      // sceneEvents.off(EVENT_GAME_UPDATESCORE);
    };
    this.events.once(Phaser.Scenes.Events.DESTROY, eventsOff);
    this.events.once(Phaser.Scenes.Events.SHUTDOWN, eventsOff);
  }
}
